import Swal from "sweetalert2";
import { useLocation } from 'react-router-dom';
import { useEffect } from "react";


// @ts-ignore
export default function PopUp(props: any) {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    let dato = params.get('nombre');
    let direccion: any = params.get('direccion');

    async function pop() {

        Swal.fire({
            title: "Correcto",
            html: "Ticket correctamente generado, con el número <b>" + dato + "</b>",
            text: "Text",
            icon: "success",
        }).then(async()=> {

           await redirect();           
        });

    }

    async function redirect(){

        window.location.href = direccion;
    }

    useEffect(() => {
    
        pop();
    
      return () => {
      }

    //@ts-ignore
    }, [])
    

    return (
        <>
          

         

        </>
    )


}